"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[8186],{

/***/ 28186:
/***/ ((module) => {

module.exports = JSON.parse('{"taskGroupSaved":"Template group saved","somethingWentWrong":"Something went wrong!","pleaseTryAgainOrContactSupport":"Please try again. If the problem persists, contact support.","taskGroupDeleted":"Template group removed"}');

/***/ })

}]);